import { Link } from 'react-router-dom'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Router } from '$utils/router'

type PetOptionSettingsLinkProps = {
  type: 'size' | 'coat'
}

export function PetOptionSettingsLink({ type }: PetOptionSettingsLinkProps) {
  const path = type === 'size'
    ? Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsPetOptionsSizes)
    : Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsPetOptionsCoats)

  const topic = type === 'size'
    ? 'size categories and weight bands'
    : 'coat types'

  return (
    <p className="text-xs text-gray-500 mt-1 leading-relaxed">
      You can add new options or edit{' '}
      {topic}
      {' '}
      in{' '}
      <Link
        to={path}
        className="font-medium text-gray-700 underline underline-offset-2 decoration-gray-400 hover:text-gray-900 hover:decoration-gray-600"
      >
        settings
      </Link>
      .
    </p>
  )
}
